<template>
  <div v-if="vendors.length > 1" class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-none d-sm-block h2 mb-0">
      {{ titleProductsFrom }} {{ activeVendorFilter || titleAllVendors }}
    </div>
    <button
      v-open-modal="'essentialsVendorSelector'"
      class="btn btn-secondary-subtle button-wrapper"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="content-wrapper">
          <div class="text-xs title text-muted mb-1">{{ textVendors }}</div>
          <div class="h6 current-choice mb-0 text-dark text-left">
            {{ activeVendorFilter || textAllVendors }}
          </div>
        </div>
        <ChevronDown class="ml-3 svg-24 svg-fill-gray-500" />
      </div>
    </button>
  </div>
</template>

<script>
import ChevronDown from "../../../../icons/atalanda/chevron-down.svg";
import { mapGetters } from "vuex";

export default {
  name: "Selector",
  components: {
    ChevronDown,
  },
  props: {
    textAllVendors: {
      type: String,
      required: true,
    },
    titleProductsFrom: {
      type: String,
      required: true,
    },
    titleAllVendors: {
      type: String,
      required: true,
    },
    textVendors: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeVendorFilter: "lists/vendorFilter",
      vendors: "lists/getFilterableVendors",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.title {
  opacity: 0.8;
  text-transform: uppercase;
}

.button-wrapper {
  width: 100%;

  @media (min-width: $screen-sm-min) {
    width: auto;
  }
}

.content-wrapper {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
</style>
